import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

export interface SideMenuLink {
  url?: string;
  name: string;
  icon?: string;
  queryParams?: { [k: string]: any };
  hidden?: boolean;
  action?: number;
  isActiveAction?: boolean;
}

@Component({
  selector: 'cm-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideMenuComponent {
  @Input() links: SideMenuLink[];
  @Output() onAction: EventEmitter<number> = new EventEmitter();

  doAction(event, link: SideMenuLink) {
    if (link.action) {
      event.stopPropagation();
      this.onAction.emit(link.action);
    }
  }
}
